// src/contexts/MeetingModeContext.jsx
import { createContext, useEffect, useState } from 'react';
import { getMeetingMode } from '../utils/meetingMode';

/**
 * Meeting Mode Context
 * Provides global meeting mode state to all components
 */
export const MeetingModeContext = createContext({ 
  meetingMode: false 
});

/**
 * Meeting Mode Provider Component
 * Wraps the app to provide meeting mode state globally
 */
export default function MeetingModeProvider({ children }) {
  const [meetingMode, setMeetingMode] = useState(getMeetingMode());

  useEffect(() => {
    // Listen for meeting mode changes
    const onChange = (e) => {
      const newValue = typeof e.detail?.val === 'boolean' 
        ? e.detail.val 
        : getMeetingMode();
      setMeetingMode(newValue);
    };

    window.addEventListener('dva:meetingModeChanged', onChange);
    
    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('dva:meetingModeChanged', onChange);
    };
  }, []);

  return (
    <MeetingModeContext.Provider value={{ meetingMode }}>
      {children}
    </MeetingModeContext.Provider>
  );
}